<template>
  <div class="q-px-sm q-py-xs rounded bg-red-5">
    {{ helper.message }}
  </div>
</template>

<script>
export default {
  name: 'HelperErrorMessage',
  props: {
    helper: {
      type: Object,
      default () {
        return { message: '', state: 'inactive' }
      }
    }
  }
}
</script>
